import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';
import { getAuth, GoogleAuthProvider } from 'firebase/auth';

const firebaseConfig = {
  apiKey: 'AIzaSyA5goTYbNs_6EpD3F8xfsCFNCF7bNF4jzE',
  authDomain: 'lihuhu-admin-tool.firebaseapp.com',
  projectId: 'lihuhu-admin-tool',
  storageBucket: 'lihuhu-admin-tool.appspot.com',
  messagingSenderId: '974369270333',
  appId: '1:974369270333:web:98d845644ecec84bd69854',
};

export const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);
export const storage = getStorage(firebaseApp);
export const auth = getAuth(firebaseApp);
export const googleProvider = new GoogleAuthProvider();
